module.exports = __webpack_public_path__ + "img/hand-three.dc08129d.png";